export const extendedVideo = editor => {
  const type = 'video';
  const yt = 'yt';
  const vi = 'vi';
  const ytnc = 'ytnc';

  editor.DomComponents.addType('video', {
    isComponent: el => {
      let result = '';
      const { tagName, src } = el;
      const isYtProv = /youtube\.com\/embed/.test(src);
      const isYtncProv = /youtube-nocookie\.com\/embed/.test(src);
      const isViProv = /player\.vimeo\.com\/video/.test(src);
      const isExtProv = isYtProv || isYtncProv || isViProv;
      if ((tagName ?? '').toLowerCase() === type || ((tagName ?? '').toLowerCase() === 'iframe' && isExtProv)) {
        result = { type: 'video' };
        if (src) result.src = src;
        if (isExtProv) {
          if (isYtProv) result.provider = yt;
          else if (isYtncProv) result.provider = ytnc;
          else if (isViProv) result.provider = vi;
        }
      }
      return result;
    },
    model: {
      init() {
        this.getYoutubeTraits = () => {
          return [
            this.getProviderTrait(),
            {
              label: 'Video ID',
              name: 'videoId',
              placeholder: 'eg. jNQXAC9IVRw',
              changeProp: 1
            },
            this.getAutoplayTrait(),
            this.getLoopTrait(),
            this.getControlsTrait(),
            {
              type: 'checkbox',
              label: 'Related',
              name: 'rel',
              changeProp: 1
            },
            {
              type: 'checkbox',
              label: 'Modest',
              name: 'modestbranding',
              changeProp: 1
            },
            {
              type: 'checkbox',
              label: 'Muted',
              name: 'muted',
              changeProp: true
            }
          ];
        };

        this.getVimeoTraits = () => {
          return [
            this.getProviderTrait(),
            {
              label: 'Video ID',
              name: 'videoId',
              placeholder: 'eg. 123456789',
              changeProp: 1
            },
            {
              label: 'Color',
              name: 'color',
              placeholder: 'eg. FF0000',
              changeProp: 1
            },
            this.getAutoplayTrait(),
            this.getLoopTrait(),
            {
              type: 'checkbox',
              label: 'Muted',
              name: 'muted',
              changeProp: true
            }
          ];
        };

        this.getSourceTraits = () => {
          return [
            this.getProviderTrait(),
            {
              label: 'Source',
              name: 'src',
              placeholder: 'eg. ./media/video.mp4',
              changeProp: 1
            },
            {
              label: 'Poster',
              name: 'poster',
              placeholder: 'eg. ./media/image.jpg'
              // changeProp: 1
            },
            this.getAutoplayTrait(),
            this.getLoopTrait(),
            this.getControlsTrait(),
            {
              type: 'checkbox',
              label: 'Muted',
              name: 'muted',
              changeProp: true
            }
          ];
        };

        this.getYoutubeSrc = () => {
          const id = this.get('videoId');
          let url = this.get('ytUrl');
          const list = this.get('list');
          url += id + (id.indexOf('?') < 0 ? '?' : '');
          url += list ? `&list=${list}` : '';
          url += this.get('autoplay') ? '&autoplay=1' : '';
          url += !this.get('controls') ? '&controls=0&showinfo=0' : '';
          // Loop works only with playlist enabled
          // https://stackoverflow.com/questions/25779966/youtube-iframe-loop-doesnt-work
          url += this.get('loop') ? `&loop=1&playlist=${id}` : '';
          url += this.get('rel') ? '' : '&rel=0';
          url += this.get('modestbranding') ? '&modestbranding=1' : '';
          url += this.get('muted') ? '&mute=1' : '';
          return url;
        };

        this.getVimeoSrc = () => {
          var url = this.get('viUrl');
          url += this.get('videoId') + '?';
          url += this.get('autoplay') ? '&autoplay=1' : '';
          url += this.get('loop') ? '&loop=1' : '';
          url += !this.get('controls') ? '&title=0&portrait=0&badge=0' : '';
          url += this.get('color') ? '&color=' + this.get('color') : '';
          url += this.get('muted') ? '&muted=1' : '';
          return url;
        };

        this.parseFromSrc = () => {
          var prov = this.get('provider');
          var uri = this.parseUri(this.get('src'));
          var qr = uri.query;
          switch (prov) {
            case yt:
            case ytnc:
            case vi:
              var videoId = uri.pathname.split('/').pop();
              this.set('videoId', videoId);
              qr.list && this.set('list', qr.list);
              if (qr.autoplay) this.set('autoplay', 1);
              if (qr.loop) this.set('loop', 1);
              if (parseInt(qr.controls) === 0) this.set('controls', 0);
              if (qr.color) this.set('color', qr.color);
              if (qr.rel === '0') this.set('rel', 0);
              if (qr.modestbranding === '1') this.set('modestbranding', 1);
              if (qr.muted === '1') this.set('muted', true);
              if (qr.mute === '1') this.set('muted', true);
              break;
            default:
          }
        };
        this.baseGetAttrToHTML = this.getAttrToHTML;

        this.getAttrToHTML = (...args) => {
          var attr = this.baseGetAttrToHTML.apply(this, args);
          var prov = this.get('provider');
          switch (prov) {
            case yt:
            case ytnc:
            case vi:
              break;
            default:
              if (this.get('loop')) attr.loop = 'loop';
              if (this.get('autoplay')) attr.autoplay = 'autoplay';
              if (this.get('controls')) attr.controls = 'controls';
              attr.muted = !!this.get('muted');
          }
          return attr;
        };

        if (this.get('src')) this.parseFromSrc();
        this.updateTraits();
        this.listenTo(this, 'change:provider', this.updateTraits);
        this.listenTo(this, 'change:videoId change:provider', this.updateSrc);
      },
      defaults: {}
    },
    view: {
      init() {
        const { model } = this;

        this.updateVideo = () => {
          var prov = this.model.get('provider');
          var videoEl = this.videoEl;
          var md = this.model;
          switch (prov) {
            case 'yt':
            case 'ytnc':
            case 'vi':
              this.model.trigger('change:videoId');
              break;
            default:
              videoEl.loop = md.get('loop');
              videoEl.autoplay = md.get('autoplay');
              videoEl.controls = md.get('controls');
              videoEl.poster = md.get('poster');
              videoEl.muted = md.get('muted');
          }
        };

        this.listenTo(model, 'change:muted', this.updateVideo);
      }
    }
  });
};
